import bem from 'utils/bem';

export const block = bem('audio-clip-suggestion-preview-card');
